// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";

// BBWT
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppAutoUpdateComponent } from "@main/app-versioning/components/app-auto-update.component";
import { AppVersionInterceptor } from "@main/app-versioning/api/app-version.interceptor";
import { AppVersionService } from "@main/app-versioning/api/app-version.service";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppVersionHub } from "@main/app-versioning/api/app-version.hub";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { SidebarModule } from "primeng/sidebar";
import { TooltipModule } from "primeng/tooltip";
import { ButtonModule } from "primeng/button";
import { PrimeNgModule } from "@primeng";

@NgModule({
    declarations: [
        AppAutoUpdateComponent
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        SidebarModule,
        ButtonModule,
        TooltipModule,
        PrimeNgModule,
    ],
    providers: [{
        provide: HTTP_INTERCEPTORS,
        useClass: AppVersionInterceptor,
        multi: true
    },
        AppVersionHub,
        AppVersionService
    ],
    exports: [
        AppAutoUpdateComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppVersioningModule {
}